import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

// languages/tvShowLanguages is an action type prefix and is used
// internally with pending, fulfilled, rejected
// each of these createAsyncThunks return promises
export const fetchTVShowLanguages = createAsyncThunk(
  "languages/tvShowLanguages",
  async () => {
    console.log("calling GET tv show languages...");
    const response = await axios.get(`${BASE_URL}/api/tvshow/languages`);
    console.log("GET tvs show languages response: ", response);
    return response.data;
  }
);

const tvShowLanguageSlice = createSlice({
  name: "tvShowLanguages",
  initialState: {
    tvShowLanguages: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      // fetch tv show languages
      .addCase(fetchTVShowLanguages.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTVShowLanguages.fulfilled, (state, action) => {
        state.tvShowLanguages = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchTVShowLanguages.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default tvShowLanguageSlice.reducer;
